'use client'

import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { EditNames } from './_components/editnames'
import { EditPassword } from './_components/editpassword'
import { Card, CardContent } from '@/components/ui/card'
import { queryKeys, useAccount } from '@/hooks/queries'
import { Skeleton } from '@/components/ui/skeleton'
import { PageContainer } from '@/components/page-container'
import Cookies from 'js-cookie'

interface UserInfo {
  username: string
  first_name: string
}

export default function EditProfile() {
  // Тот же кэш аккаунта, что и на /profile — без повторного запроса.
  const { data, isLoading } = useAccount()
  const userInfo = data as (UserInfo & { email: string }) | undefined
  const queryClient = useQueryClient()

  useEffect(() => {
    if (userInfo?.email) {
      Cookies.set('email', userInfo.email, { expires: 7 })
    }
  }, [userInfo?.email])

  // После сохранения имени инвалидируем кэш — данные перезагрузятся свежими.
  const handleUpdateSuccess = () => {
    queryClient.invalidateQueries({ queryKey: queryKeys.account })
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-950">
        <PageContainer className="py-8">
          <div className="space-y-8">
            <Skeleton className="h-12 w-[250px]" />
            <div className="grid gap-8 md:grid-cols-2">
              <Skeleton className="h-[400px]" />
              <Skeleton className="h-[400px]" />
            </div>
          </div>
        </PageContainer>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-950">
    <PageContainer className="py-8">
      <div className="mb-8 animate-in fade-in-0 slide-in-from-top-2 duration-500">
        <h1 className="text-4xl font-bold mb-2 bg-gradient-to-r from-blue-400 to-purple-500 text-transparent bg-clip-text">
          Редактирование профиля
        </h1>
        <p className="text-xl text-gray-300 mb-4">Измените ваши личные данные и пароль</p>
      </div>

      <div className="grid gap-8 md:grid-cols-2">
        <Card
          className="bg-gray-800/50 border-gray-700 backdrop-blur-sm animate-in fade-in-0 slide-in-from-bottom-2 duration-500 fill-mode-both"
          style={{ animationDelay: '100ms' }}
        >
          <CardContent className="pt-6">
            {userInfo && (
              <EditNames
                currentUsername={userInfo.username}
                currentFirstname={userInfo.first_name}
                onSuccess={handleUpdateSuccess}
              />
            )}
          </CardContent>
        </Card>

        <Card
          className="bg-gray-800/50 border-gray-700 backdrop-blur-sm animate-in fade-in-0 slide-in-from-bottom-2 duration-500 fill-mode-both"
          style={{ animationDelay: '200ms' }}
        >
          <CardContent className="pt-6">
            <EditPassword email={userInfo?.email} />
          </CardContent>
        </Card>
      </div>
    </PageContainer>
    </div>
  )
}